// ??????
const nofilters = ['/resetLogin', '/register']
export default function(path) {
  return nofilters.some(o => new RegExp(o).test(path))
}



// WEBPACK FOOTER //
// ./src/router/filter.js